__turbopack_context__.v({
  "actions": "_7BZdkG_actions",
  "alert": "_7BZdkG_alert",
  "cardContent": "_7BZdkG_cardContent",
  "cell": "_7BZdkG_cell",
  "clearance": "_7BZdkG_clearance",
  "columnGroup": "_7BZdkG_columnGroup",
  "columnGroups": "_7BZdkG_columnGroups",
  "contentInset": "_7BZdkG_contentInset",
  "dividedRows": "_7BZdkG_dividedRows",
  "groupGap": "_7BZdkG_groupGap",
  "groupHeader": "_7BZdkG_groupHeader",
  "groupLabel": "_7BZdkG_groupLabel",
  "groupToggle": "_7BZdkG_groupToggle",
  "header": "_7BZdkG_header",
  "hoverActions": "_7BZdkG_hoverActions",
  "insetEnd": "_7BZdkG_insetEnd",
  "insetStart": "_7BZdkG_insetStart",
  "itemButton": "_7BZdkG_itemButton",
  "linked": "_7BZdkG_linked",
  "overflowLane": "_7BZdkG_overflowLane",
  "pagination": "_7BZdkG_pagination",
  "pinned": "_7BZdkG_pinned",
  "root": "_7BZdkG_root",
  "row": "_7BZdkG_row",
  "rowLink": "_7BZdkG_rowLink",
  "scrollAffordance": "_7BZdkG_scrollAffordance",
  "scrollLg": "_7BZdkG_scrollLg",
  "scrollMd": "_7BZdkG_scrollMd",
  "scrollXl": "_7BZdkG_scrollXl",
  "selection": "_7BZdkG_selection",
  "sortCaret": "_7BZdkG_sortCaret",
  "span": "_7BZdkG_span",
  "subtleBorder": "_7BZdkG_subtleBorder",
  "surface": "_7BZdkG_surface",
  "table": "_7BZdkG_table",
  "treeIndent": "_7BZdkG_treeIndent",
  "treePanel": "_7BZdkG_treePanel",
  "viewportCentered": "_7BZdkG_viewportCentered",
});
